<template>
  <div class="article-detail">
    <v-container>
      <v-mockup widget="article-detail" v-if="!isLoaded" />
      <article v-else>
        <div class="article-detail__top">
          <v-heading level="h1">{{article.title}}</v-heading>
          <time>{{article.time}}</time>
          <v-heading level="h4" weight="regular">{{article.subtitle}}</v-heading>
        </div>
        <social-sharing :url="$route.fullPath"
          :title="article.title"
          :description="article.subtitle"
          inline-template>
          <div class="article-detail__share">
            <p>Compartilhe</p>
            <network network="facebook"><i class="icon-facebook"></i></network>
            <network network="twitter"><i class="icon-twitter"></i></network>
          </div>
        </social-sharing>
        <img class="article-detail__img" v-if="article.img" :src="article.img" :alt="article.title">
        <body-text v-html="article.text">
        </body-text>
        <social-sharing :url="$route.fullPath"
          :title="article.title"
          :description="article.subtitle"
          inline-template>
          <div class="article-detail__share">
            <p>Compartilhe</p>
            <network network="facebook"><i class="icon-facebook"></i></network>
            <network network="twitter"><i class="icon-twitter"></i></network>
          </div>
        </social-sharing>
      </article>
    </v-container>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import Container from '@/components/layout/Container.vue';
import Heading from '@/components/uikit/text/Heading.vue';
import BodyText from '@/components/uikit/text/BodyText.vue';
import Mockup from '@/components/uikit/mockup/Mockup.vue';
import Btn from '@/components/uikit/Btn.vue';

export default {
  name: 'ArticlesList',
  components: {
    'v-container': Container,
    'v-heading': Heading,
    'v-mockup': Mockup,
    'body-text': BodyText,
  },
  metaInfo() {
    return {
      title: this.isLoading ? 'Carregando...' : this.article.title,
      meta: [
        { name: 'og:title', content: this.article.title, vmid: 'og:title' },
        { name: 'og:description', content: this.article.subtitle, vmid: 'og:description' },
        { name: 'og:image', content: this.article.img, vmid: 'og:image' },
      ],
    };
  },
  computed: {
    ...mapState({
      article: state => state.articles.article,
    }),
    ...mapGetters({
      isLoading: 'articles/isLoading',
      isLoaded: 'articles/isLoaded',
    }),
    source() {
      const source = this.$route.fullPath.split('/')[1];
      switch (source) {
        case 'publicacoes':
          return 'publication';
        case 'area-medica':
          return 'medical-area';
        default:
          return 'articles';
      }
    },
  },
  async created() {
    await this.$store.dispatch('articles/fetchArticle', {
      slug: this.$route.params.slug,
      source: this.source,
    }).then((resp) => {
      if (resp.errors) {
        this.$router.replace('/404');
      }
    });
  },
  destroyed() {
    this.$store.commit('articles/setArticle', {});
  },
};
</script>

<style lang="scss" scoped>
$component: '.article-detail';
#{$component} {
  padding: $section-gutter 0;
  background-color: $bg-gray;
  &__top,
  .body-text {
    padding: 0 8.333%;
    @media screen and (max-width: #{$brakepoint-medium}) {
      padding: unset;
    }
  }
  &__top {
    margin-bottom: $gutter-xxl;
    h1 {
      color: $color-sys-b;
    }
    time {
      display: block;
      margin-bottom: $gutter-xl;
      color: $color-sys-g;
    }
    h4 {
      color: $color-sys-e;
      font-size: $font-size-xl;
    }
  }
  &__img {
    display: block;
    margin-bottom: $gutter-xxl;
    max-width: 100%;
  }
  &__share {
    padding: $gutter-l;
    margin-bottom: $gutter-xxl;
    background-color: $color-sys-k;
    border-radius: $border-radius;
    text-align: center;
    /deep/ p {
      margin: 0 0 $gutter;
      font-size: $font-size;
      font-weight: $font-weight-heavy;
      color: $color-sys-d;
    }
    /deep/ span {
      display: inline-block;
      margin: 0 $gutter-l;
      text-decoration: none;
      cursor: pointer;
      transition: opacity $transition-duration $transition-timing-function;
      &:hover {
        opacity: 0.6;
      }
    }
  }
}
</style>
